import * as React from 'react';
import { resolveTemplate } from './resolveTemplate';
import { inlineStylesFromPosition, positionForScreen } from './grid';
import { IProductCardILayoutTypes, IProductCardILayoutVersions, IScreenType } from '@thryveai/theme-interfaces';
import { svgComponents } from './Atoms';
import './_styles.scss';

interface ISvgProductCardProps {
  location: IProductCardILayoutTypes;
  layout: IProductCardILayoutVersions;
  screenSize: IScreenType;
  className?: string;
  title?: string;
}
const SvgProductCard: React.FC<ISvgProductCardProps> = (props) => {
  const { location, layout, screenSize, className, title } = props;
  const { template } = resolveTemplate(location, layout);

  const rootClass = React.useMemo(() => {
    const locationClassMap: Record<IProductCardILayoutTypes, string> = {
      ContainersGrid: 'pc--grid',
      ContainersCarousel: 'pc--carousel',
      FlyerCard: 'pc--flyer',
    };
    const mapped = locationClassMap[location];
    const locationClass = mapped || `pc--${String(location).toLowerCase()}`;
    const layoutClass = `pc--layout-${layout}`;
    return ['pc', locationClass, layoutClass, className].filter(Boolean).join(' ');
  }, [location, layout, className]);

  return (
    <div className="pc__section-container">
      {title && <h6 className="pc__section-title">{title}</h6>}
      <div className={rootClass}>
        {Object.keys(template).map((sectionKey) => {
          const section = template[sectionKey];
          const sectionPosition = positionForScreen(section.sectionPosition, screenSize);
          if (!sectionPosition || sectionPosition === 'hidden') {
            return null;
          }
          return (
            <div
              key={sectionKey}
              className={`pc__section pc__section--${sectionKey}`}
              style={{
                display: 'grid',
                ...inlineStylesFromPosition(sectionPosition),
              }}
            >
              {section.children.map((child, idx) => {
                const childPosition = positionForScreen(child.sectionPosition, screenSize);
                if (!childPosition || childPosition === 'hidden') {
                  return null;
                }
                const name = child.component;
                const Comp = svgComponents[name];
                if (!Comp) {
                  return null;
                }

                const extraProps = {
                  ...(name === 'AddToCartButton' || name === 'ViewDealButton' || name === 'ProductCoupons'
                    ? { fullWidth: true }
                    : {}),
                  ...(name === 'ProductImage' && screenSize === 'mobile' && location !== 'ContainersCarousel'
                    ? { width: 80, height: 80 }
                    : {}),
                };

                return (
                  <div
                    key={`${sectionKey}-${name}-${idx}`}
                    className={`pc__child pc__child--${name}`}
                    style={inlineStylesFromPosition(childPosition)}
                  >
                    {name === 'ProductAttributes' ? (
                      <>
                        <Comp fill="#3A80D260" />
                        <Comp fill="#f2c94c60" />
                        <Comp fill="#10b98160" />
                      </>
                    ) : (
                      <Comp {...extraProps} />
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SvgProductCard;
